// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"Spinner_lds-dual-ring__rW9j6","spinner-container":"Spinner_spinner-container__nA019"};